import * as React from "react";
import ImageTextList, { ImageTextListProps } from "~/components/image-text-list/image-text-list";

export interface ImageTextListViewProps {
    contextModel: ImageTextListProps;
}

class ImageTextListView extends React.Component<ImageTextListViewProps> {
    public render() {
        return <ImageTextList {...this.props.contextModel} />;
    }
}

export default ImageTextListView;
